// @flow
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import NearbyConsultants from "../views/NearbyConsultantsView";
import ContactRepView from "../views/ContactRepView";
import FourOhFourView from "../views/FourOhFourView";
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'

class AppSearchPluginRoutes extends Component {
    render() {
        return (
            <CacheSwitch>
                <Route exact path="/:shopName?/contactrep/" component={ContactRepView} />
                <CacheRoute exact path="/:shopName?" component={NearbyConsultants} />
                <Route component={FourOhFourView} />
            </CacheSwitch>
        );
    }
}
export default AppSearchPluginRoutes
